import VideoSection from './video-section';

export default VideoSection;
